import React from 'react';
import Layout from '../components/layout/Layout';
import VitalTestList from '../components/vitaltests/VitalTestList';
import VitalTestModal from '../components/vitaltests/VitalTestModal';
import { VitalTestProvider } from '../contexts/VitalTestContext';

const VitalTestMastersPage = () => {
  return (
    <Layout>
      <VitalTestProvider>
        <VitalTestList />
        
        {/* Modal for creating/editing vital tests */}
        <VitalTestModal />
      </VitalTestProvider>
    </Layout>
  );
};

export default VitalTestMastersPage;
